export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'CONFIG': 'Settings',
            'TOOLS': {
              'TITULO': 'Tools',
              'CHAT': 'Chat',
              'TODO': 'To-Do list',
              'BROKER': 'Configuration by broker',
              'CHANGELOG': 'Changelog',
              'KNOWLEDGE': 'Knowledge base',
              'WEB_COM_PROF':'Web company profile',
            },
            'RESULTS': {
              'TITULO': 'Results',

              'ENLACES': {
                'TI': 'Reporting',
                'TI_ESPANA': 'Online Reports',
                'COVID': 'COVID Survey results'
              },
              'ENLACES5': {
                'TI': 'Reults 5.0',
                'COVID': 'Covid survey resullts'
              },
              'ENLACES_ACTION_GO':{
                'TITULO':'ActionGo',
                // 'TITULO':'Action Plan - Leaders',
              },
              'ENLACES_GO_FLOW':{
                'TITULO':'Go Flow Results',
              }
            },
            'ACADEMY'        : {
                'TITULO': 'Test Academy',
                'BADGE': '69'
            },
            'CERTIFICAR'        : {
                'TITULO': 'Certify',
                'TITULOIZZI': 'Izzi',
                'TITULO_ESPAIN': 'Diagnose',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'Certify',
                  '1': 'Certify 2.0',
                  '2': 'Izzi',
                  '3': 'Certify 3.0',
                  '4': 'Certify silver',
                  'SPA': 'Configure survey',
                  '6': 'GPWT + GCTI'
                }
            },
            'CERTIFICARN35'        : {
                'TITULO': 'Certify N35',
                'BADGE': '69'
            },
            'MEDIR'        : {
                'TITULO': 'Measurement',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'Measurement',
                  '1': 'Measurement enhanced',
                  '2': 'Measurement + MST',
                  '3': 'Measurement by areas',
                  '4': 'Measurement by leaders',
                  '5': 'Measurement by dimensions',
                  '6': 'Measurement to certify',
                  '7': 'Measurement 3.0',
                  '8': 'ICI'
                }
            },
            'PULSE'        : {
                'TITULO': 'Pulse Check',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'Pulse Check',
                  '1': 'Pulse Check 3.0',
                }
            },
            'FOCUS'        : {
                'TITULO': 'Focus Area',
                'BADGE': '69'
            },
            'ENCUESTAS'        : {
                'TITULO': 'Additional certifications',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'AMCO',
                  '1': 'Decent work',
                  '2': 'First job',
                }
            },
            'NORMA35': {
                'TITULO': 'Norm 035'
            },
            'NOM35BETHE': {
                'TITULO': 'Norm 035 better'
            },
            'NOM35PLA': {
                'TITULO': 'Norm 035 silver'
            },
            'NOM35V3': {
                'TITULO': 'Norm 035 3.0'
            },
            'LANGUAJE'        : {
                'TITULO': 'Test languaje',
                'BADGE': '69'
            },
            'LOGIN'        : {
                'TITULO': 'Test login',
                'BADGE': '69'
            },
            'PROFILECREATOR'        : {
                'TITULO': 'Profiles creator',
                'BADGE': '69'
            },
            'PROFILELIST'        : {
                'TITULO': 'Companies information',
                'BADGE': '69'
            },
            'NOPRODUCTOS'        : {
                'TITULO': 'You have no products',
                'BADGE': '69'
            },
            'RESPTI': {
              'TITULO': 'IT Manager'
            },
            'REQTEC': {
              'TITULO': 'Technical requirements'
            },
            'CLOUD': {
              'TITULO': 'File manager',
              'TITULO_ESPANA': 'Report Downloads',
            },
            //Culture Audit
            'CULTURE': {
              'TITULO': 'Culture Audit'
            },
            //Culture Audit2
            'CULTURE2': {
              'TITULO': 'Culture Audit 5.0'
            },
            //Culture Audit training
            'CATR': {
              'TITULO': 'Culture Audit Training'
            },
            //Feedback
            'FEEDBACK': {
              'TITULO': 'Feedback'
            },
            //Acercade
            'ABOUT': {
              'TITULO':'Changelog'
            },
            'QUESTIONS': {
              'TITULO':'Most frequently questions'
            },
            'VIDEOS': {
              'TITULO':'Instructional videos'
            },
            'CONSULTAR_E': {
              'TITULO':'Consult surveys'
            },
            'CALEND_SUR': {
              'TITULO':'Survey Calendar'
            },
            'VIDEOSADMIN': {
              'TITULO':'Administrator video'
            },
            'AUDITORIA-AUTO': {
              'TITULO':'Automated audit'
            },
            'LOG_SISTEMA': {
              'TITULO':'System Log'
            },
            'TIPS': {
              'TITULO':'Norma tips'
            },
            'ENCUESTA': {
              'TITULO':'Colaboradores nuevos'
            },
            'CULTURETURQUIA1': {
              'TITULO': 'Culture Brief ve Culture Audit 5.0'
            },
            'CULTURETURQUIA2': {
              'TITULO': 'Culture Brief 5.0'
            },
            'CULTURETURQUIA3': {
              'TITULO': 'Culture Audit 5.0'
            },

            'CULTUREMX1': {
              'TITULO': 'Culture Audit 5.0'
            },
            'CULTUREMX2': {
              'TITULO': 'Culture Audit Costa Rica'
            },
            'CULTUREMX3': {
              'TITULO': 'Culture Audit GoFlow'
            },
            'CULTUREMX4': {
              'TITULO': 'Culture Audit 5.0 Panama'
            },
            'CULTUREMX5': {
              'TITULO': 'Culture Audit 5.0 Strategic Partners'
            },
            'CULTUREMX6': {
              'TITULO': 'Culture Audit 2021 México'
            },
            'CULTUREMX7': {
              'TITULO': 'Culture Audit 2021 Costa Rica'
            },
            'CULTUREMX8': {
              'TITULO': 'Culture Audit 2021 Panamá'
            },
            'CULTUREMX9': {
              'TITULO': 'SP 2021'
            },
            'CULTUREMX10': {
              'TITULO': 'Culture Audit GoFlow 2-2021'
            },
            'CULTUREMX11': {
              'TITULO': 'SP 2022'
            },
            'CULTUREMX12': {
              'TITULO': 'Culture Audit GoFlow 2-2022'
            },
            'CULTUREMX13': {
              'TITULO': 'Culture Audit Standard 1',
            },
            'CULTUREMX14': {
              'TITULO': 'Culture Audit® CA&C'
            },
            'CULTUREMX15': {
              'TITULO': 'Culture audit (certify) 2022'
            },
            'CULTUREMX16': {
              'TITULO': 'Cultural audit (certify, rkg.) 2022'
            },
            'CULTUREMX17': {
              'TITULO': 'Culture Audit (certify, rkg. y adic.) 2022'
            },
            'CULTUREMX18': {
              'TITULO': 'Culture Audit (certify, rkg. y adic.) 2024'
            },
            'CULTUREMX19': {
              'TITULO': 'Culture Brief (certify) 2024'
            },
            'CULTUREMX20': {
              'TITULO': 'Auditoria de Cultura (certificar e classificar) 2024'
            },
            'CULTURECH1': {
              'TITULO': 'Culture Audit'
            },
            'CULTURECH2': {
              'TITULO': 'Culture Audit 5.0'
            },
            'CULTURECH3': {
              'TITULO': 'Culture Audit SP'
            },
            'CULTURECH4': {
              'TITULO': 'Culture Audit 5.0'
            },
            'CULTURECH5': {
              'TITULO': 'Culture Audit 4All'
            },
            'CULTUREESP1':{
              'TITULO': 'Culture Audit'
            },
            'CULTUREESP2':{
              'TITULO': 'Culture Audit 5.0'
            },
            'CULTUREESP3':{
              'TITULO': 'Action Plan'
            },
            'CULTUREBRI':{
              'TITULO': 'Culture Brief',
              'Culture Brief': 'Culture Brief',
            },
            'CULTUREAUDI':{
              'TITULO': 'Culture Audit',
              'Culture Audit': 'Culture Audit',
            },
            'CULTUREBRIEFAUDI':{
              'TITULO': 'Culture Brief + Culture Audit',
              'Culture Audit': 'Culture Brief + Culture Audit',
            },
            'CULTUREAMCO':{
              'TITULO': 'Internal Communication Culture Audit (ICCA)'
            },
            'CONTACTO':{
              'TITULO': 'Contact'
            },
            'ACTIONGOADMIN':{
              'TITULO': 'Action GO® administrator'
            },
            'ACTIONGO':{
              'TITULO': 'Action GO®'
            },
            'LEADERGOADMIN':{
              'TITULO': 'Leader GO® administrator',
            },
            'LEADERGOUSER':{
              'TITULO': 'Leader GO®',
            },
            'medir_INNO':{
              'TITULO': 'Innmotion survey',
            },
            'CULTURE_OZEL':{
              'TITULO': 'Special List',
            },
            'Culture_Ozel_TR1':{
              'TITULO': 'Social Responsibility and Volunteering',
            },
            'CONTROL_SURVE':{
              'TITULO': 'Survey control',
            },
            'CONSUL_REQUE':{
              'TITULO': 'Consult requirements',
            },
            'SURVEY_GENERIC':{
              'TITULO': 'Generic survey report',
            },
            'RAWDATA_FINDER':{
              'TITULO': 'Consult Raw Data',
            },




        }
    }
};
